import { FeedItem, NotificationOrigin } from '../../../domain/models/notifications/notification.model';
import { getNotificationSenderName } from '../../../domain/models/notifications/notification-display.util';
import { initialsFromName } from '../messaging/chat-color.util';

const NOTIFICATION_AVATAR_PALETTE = [
  { background: '#FDECF4', color: '#B42362' },
  { background: '#E8F1FF', color: '#2457C5' },
  { background: '#E7F6EC', color: '#237A45' },
  { background: '#FDECEC', color: '#B33A3A' },
  { background: '#F2ECFA', color: '#7047A3' },
  { background: '#FBF3DD', color: '#946200' },
  { background: '#E3F8F3', color: '#147D6F' },
  { background: '#FCEFE6', color: '#A14F20' },
  { background: '#EDECFB', color: '#5546A7' },
  { background: '#E8F5F7', color: '#246D78' },
] as const;

export interface NotificationIdentity {
  author: string;
  origin: NotificationOrigin;
  avatarText: string;
  avatarBackground: string | null;
  avatarBorderColor: string | null;
  avatarColor: string | null;
  avatarImageUrl: string | null;
}

export function getNotificationIdentity(notification: FeedItem): NotificationIdentity {
  const author = getNotificationSenderName(notification);
  const origin = resolveOrigin(notification);

  if (origin === 'SYSTEM') {
    return {
      author,
      origin,
      avatarText: '',
      avatarBackground: null,
      avatarBorderColor: null,
      avatarColor: null,
      avatarImageUrl: '/favicon.ico',
    };
  }

  const colors = notificationAvatarColors(notification.senderUserId ?? author);

  return {
    author,
    origin,
    avatarText: initialsFromName(author) || '?',
    avatarBackground: colors.background,
    avatarBorderColor: null,
    avatarColor: colors.color,
    avatarImageUrl: null,
  };
}

export function notificationAvatarColors(identity: number | string) {
  const value = String(identity);
  let hash = 0;

  for (const character of value) {
    hash = (hash * 31 + character.charCodeAt(0)) >>> 0;
  }

  return NOTIFICATION_AVATAR_PALETTE[hash % NOTIFICATION_AVATAR_PALETTE.length];
}

function resolveOrigin(notification: FeedItem): NotificationOrigin {
  if (notification.origin === 'USER' || notification.origin === 'SYSTEM') return notification.origin;
  return notification.senderUserId == null ? 'SYSTEM' : 'USER';
}
